/**
 *  +----------------------------------------------------------------------
 *  | Copyright notion All rights reserved.
 *  +----------------------------------------------------------------------
 *  | 未经许可不能去掉notion相关版权
 *  +----------------------------------------------------------------------
 *  | Author: 诺行
 *  +----------------------------------------------------------------------
 */
import request from './../request.js'

// MBB-代理商资源记录-列表
export function listRecords(params) {
    return request({
        url: '/mbb/agent/resource/records/list.do?',
        method: 'post',
        data: params
    })
}

// MBB-代理商资源记录列表-导出
export function exportRecords(params) {
    return request({
        url: '/mbb/agent/resource/records/export.do?',
        method: 'post',
        data: params
    })
}



